import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useOfferTags } from 'cityads-v3/hooks/offers'
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles'
import darkTheme from 'cityads-v3/utils/muiTheme/darkTheme'
import { useOfferFiltersContext } from '../../OfferFilters.hooks'
import classes from './OktoberfestBanner.scss'

import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

export const OKTOBERFEST_TAG = `Oktoberfest`

const buttonTheme = createTheme({
  palette: {
    primary: {
      main: '#941F0A',
      contrastText: '#F0CE87',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          border: '2px solid #2D0C08',
        },
      }
    },
  },
})

export default function OktoberfestBanner(): JSX.Element {
  const { t } = useTranslation(['main'])
  const [, tagsByCode] = useOfferTags()
  const offerFilters = useOfferFiltersContext()

  const handleSelectTag = useCallback(() => {
    if (offerFilters.selectedFilters.fields.tags.value.includes(OKTOBERFEST_TAG)) {
      offerFilters.refresh()
    } else {
      offerFilters.selectedFilters.fields.tags.pushToArray(OKTOBERFEST_TAG)
      offerFilters.selectedFilters.handleSubmit()
    }
  }, [offerFilters])

  if (!tagsByCode?.[OKTOBERFEST_TAG]?.is_available_in_filter) {
    return null
  }

  return (
    <MuiThemeProvider theme={darkTheme}>
      <div className={classes.container}>
        <div className={classes.banner}>
          <div className={classes.text}>
            <Typography
              color="textPrimary"
              variant="h6"
              className={classes.title}
            >{t('oktoberfestBanner.title')}</Typography>
            <Typography color="textSecondary" className={classes.description}>{t('oktoberfestBanner.description')}</Typography>

            <MuiThemeProvider theme={buttonTheme}>
              <Button
                disableElevation
                color="primary"
                classes={{ root: classes.button }}
                onClick={handleSelectTag}
                variant="contained"
              >{t('oktoberfestBanner.button')}</Button>
            </MuiThemeProvider>
          </div>
        </div>
      </div>
    </MuiThemeProvider>
  )
}
